import { useState, useEffect, useRef } from "react";
import styles from "./index.module.scss";
import pillars from "../../assets/images/pillers.png";
import infiniprayer from "../../assets/images/infini-prayer.png";
import { Button } from "../../common/components/Button";
import hdbImg from "../../assets/images/hdb-banner.png";
import infiniprayeraudio from "../../assets/images/Infiniprayer.mp3";
import {
  fetchProgramsData,
  getRegistrationStatus,
  getStatusOfProgram,
} from "../../utils/registrationUtils";
import { getItemInLocalStorage } from "../../services/localStorage";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../common/components/Loader";
import {
  capitalizeName,
  downloadFileFromUrl,
  formatDateRangeToIST,
} from "../../utils/commonFunctions";
import ProgramInfoCard from "../../components/CustomSubProgram";
import ProgramInfoTable from "../../components/SubProgramTable";
import { ProgramDetails } from "../Registration";
import { parseISO, format, set } from "date-fns";
import infinipathMeet from "../../assets/images/infinipathImg.webp";
import {
  COMPLETED,
  ON_HOLD,
  PENDING,
  PENDING_APPROVAL,
  REJECTED,
  SAVE_DRAFT,
  TRAVEL_PENDING,
  WAIT_LIST,
} from "../../constants";
import caretDown from "../../assets/images/caret-down.svg";
import caretUp from "../../assets/images/caret-up.svg";
import ScrollingCountdown from "../../components/ScrollingCountdown";
import { getCall, getCallInfiniminute } from "../../services/apiService";
import CircularTimer from "../../components/CircularTimer";
import RandomLoopAudioPlayer from "../../common/components/RandomLoopAudioPlayer";
import { mahatreyaAudioMessages } from "../../constants/audoFiles";
import { endPoints } from "../../constants/urlConstants";
import nondoing from "../../assets/images/nondoing.svg";
import clsx from "clsx";
import mahatriara from "../../assets/images/mahatriara.svg";
import infiminute from "../../assets/images/Infiminute.svg";
import Footer from "../../common/components/Footer";
import pillerMobileImg from "../../assets/images/infiniminuteMobile.webp";

const InfiniPrayer: React.FC = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [currentLyricIndex, setCurrentLyricIndex] = useState(-1);
  const [showCountdown, setShowCountdown] = useState(false);
  const [showTimer, setShowTimer] = useState(false);
  const [playMahatreyaAudioMessages, setPlayMahatreyaAudioMessages] =
    useState(false);
  const [showPlayAgainButton, setShowPlayAgainButton] = useState(false);
  const audioRef = useRef(null);
  const navigate = useNavigate();
  const cardLogo: string | null = null;
  const [currentNumber, setCurrentNumber] = useState(11);
  //add the logo url that is comming back end when it was added

  const [programs, setPrograms] = useState<ProgramDetails[]>([]);
  const [loader, setLoader] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [showMoreId, setShowMoreId] = useState<string | number | null>(null);
  const [showContent, setShowContent] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  const [reloadPage, setReloadPage] = useState(false);

  const seekerDetails = getItemInLocalStorage("seekerDetails") || {};

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoader(true);
        const { programs, registrations } = await fetchProgramsData(
          seekerDetails?.id,
        );
        const programRegsitrationStatus = getStatusOfProgram(
          programs,
          registrations,
        );
        setPrograms(programRegsitrationStatus);
      } catch (error) {
        console.error("Failed to fetch data:", error);
      } finally {
        setReloadPage(false);
        setLoader(false);
      }
    };
    if (!isPlaying || reloadPage) {
      loadData();
    }
  }, [seekerDetails.id, reloadPage]);

  // Parse your LRC format lyrics
  const [lyrics] = useState([
    { time: 4.81, text: "Feeling Thy presence" },
    { time: 9.02, text: "Feeling Thy grace" },
    { time: 13.58, text: "Feeling Thy radiance" },
    { time: 18.14, text: "You are my source of faith and strength" },
    { time: 22.17, text: "You are my path and destination" },
    { time: 27.16, text: "And i am always connected to You" },
    { time: 35.31, text: "Nothing of me and everything of You" },
    { time: 44.03, text: "Lead me higher..." },
    { time: 48.58, text: "Lead me deeper..." },
    { time: 53.21, text: "Lead me beyond..." },
    { time: 57.1, text: "Lead me to You." },
  ]);
  // useEffect(() => {
  //   getCallInfiniminute("getRandomAudioNew/1")
  //     .then((response) => {
  //       console.log("response", response);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching audio URL:", error);
  //     });
  // }, []);

  useEffect(() => {
    if (currentTime >= 62 && isPlaying && audioRef.current) {
      audioRef?.current.pause();
      setShowTimer(true);
      setIsPlaying(false);
      setCurrentLyricIndex(-1);
    }
  }, [currentTime]);
  // Audio event listeners
  useEffect(() => {
    if (loader) return;
    const audio = audioRef.current;
    if (!audio) return;

    const updateTime = () => setCurrentTime(audio.currentTime);
    const handleEnded = () => {
      // Show timer when audio ends
      setShowTimer(true);
      setIsPlaying(false);
      setCurrentLyricIndex(-1);
    };

    audio.addEventListener("timeupdate", updateTime);
    audio.addEventListener("ended", handleEnded);

    return () => {
      audio.removeEventListener("timeupdate", updateTime);
      audio.removeEventListener("ended", handleEnded);
    };
  }, [loader]);

  // Update current lyric based on audio time
  useEffect(() => {
    if (!isPlaying) return;

    const currentIndex = lyrics.findIndex((lyric, index) => {
      const nextLyric = lyrics[index + 1];
      return (
        currentTime >= lyric.time &&
        (!nextLyric || currentTime < nextLyric.time)
      );
    });

    setCurrentLyricIndex(currentIndex);
  }, [currentTime, isPlaying, lyrics]);

  const handleStart = () => {
    setCurrentNumber(11); // Reset countdown number
    setShowPlayAgainButton(false);
    setPlayMahatreyaAudioMessages(false);
    setShowContent(true);
    if (isPlaying) {
      const audio = audioRef.current;
      if (audio) {
        audio.pause();
        setIsPlaying(false);
      }
    } else {
      setShowCountdown(true); // Start countdown instead of playing directly
    }
  };

  const handleCountdownComplete = async () => {
    setShowCountdown(false);
    setIsPlaying(true);

    const audio = audioRef.current;
    if (!audio) return;

    try {
      await audio.play();
    } catch (error) {
      console.error("Error playing audio:", error);
    }
  };

  const handleTimerComplete = () => {
    setShowTimer(false);
    setCurrentTime(0);
    setPlayMahatreyaAudioMessages(true);
    const audio = audioRef.current;
    if (audio) {
      audio.currentTime = 0;
    }
  };

  const handleRegister = (eventId: string) => {
    navigate(`registration?programId=${eventId}`);
  };
  function formatCheckinTime(isoString: string) {
    if (!isoString) return "";
    const date = parseISO(isoString);
    return format(date, "hh:mm aaaa 'on' EEE, dd MMM yyyy")
      .replace("AM", "a.m.")
      .replace("PM", "p.m.");
  }
  function formatProgramDates(startsAt: string, endsAt: string) {
    if (!startsAt || !endsAt) return "";
    const start = parseISO(startsAt);
    const end = parseISO(endsAt);

    // Example: Wed, 18 Sep to Sat, 21 Sep 2024
    const startStr = format(start, "EEE, dd MMM");
    const endStr = format(end, "EEE, dd MMM yyyy");
    return `${startStr} to ${endStr}`;
  }
  const renderPillars = () => (
    <div className={styles.pillars_container}>
      <img src={pillars} alt="Three Pillars" className={styles.pillars_image} />
      <img
        src={pillerMobileImg}
        alt="Three Pillars Mobile"
        className={styles.pillars_image_mobile}
      />
    </div>
  );

  const renderLogos = () => {
    if (playMahatreyaAudioMessages || showPlayAgainButton) return null;
    return (
      <div className={styles.infiniminite_logo}>
        <img
          src={
            showCountdown || showTimer
              ? nondoing
              : isPlaying
                ? infiniprayer
                : infiminute
          }
          alt="Infinipath Prayer"
          className={styles.infiniprayer}
        />
      </div>
    );
  };
  const highlightMahatria = (text: string) => {
  if (!text) return null;
  return text.split(/(mahatria)/gi).map((part, idx) =>
    part.toLowerCase() === "mahatria" ? (
      <span key={idx} className={styles.mahatria}>{part}</span>
    ) : (
      part
    )
  );
};

  const renderGreetings = () => {
    return (
      <div>
        {!showCountdown &&
        !showTimer &&
        !isPlaying &&
        !showPlayAgainButton &&
        !playMahatreyaAudioMessages ? (
          <div className={styles.greeting_section}>
            <div className={styles.nameDiv}>
              Hi {capitalizeName(seekerDetails?.fullName)},
            </div>
            <div className={styles.nameDiv}>
              experience the infinite through
            </div>
          </div>
        ) : playMahatreyaAudioMessages || showPlayAgainButton ? (
          <div className={styles.greeting_section}>
            <div className={styles.nameDiv}>
              Hi {capitalizeName(seekerDetails?.fullName)},
            </div>
            <div className={styles.redBorder}></div>
            <div className={styles.nameDiv}>Loving you so much</div>
            <img
              src={mahatriara}
              alt="Mahatria ra"
              className={styles.mahatriara}
            />
          </div>
        ) : null}
      </div>
    );
  };
  if (loader && !isPlaying) {
    return <Loader type="large" />;
  }

  const onInvoiceClick = (registrationId: number) => {
    console.log("Invoice clicked, onInvoiceClick", registrationId);
    getCall(endPoints.invoiceDownload(registrationId), undefined, false)
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          console.log("response format:", response.data.data);
          downloadFileFromUrl(response.data.data.invoicePdfUrl);
        } else {
          console.error("Failed to download invoice:", response?.data?.message);
        }
      })
      .catch((error) => {
        console.error("Error downloading inv  oice:", error);
      });
    console.log("Invoice clicked, onInvoiceClick completed");
  };
  const onProformaClick = (registrationId: string) => {
    console.log("Invoice clicked , Proforma clicked");
    getCall(endPoints.proformaDownload(registrationId), undefined, false)
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          console.log("response to download invoice:", response?.data?.data);
          downloadFileFromUrl(response.data.data.data.proFormaInvoice);
        } else {
          console.error("Failed to download invoice:", response?.data?.message);
        }
      })
      .catch((error) => {
        console.error("Error downloading invoice:", error);
      });
  };
  const handleCTAClick = async (
    programId: number,
    sectionId: number,
    selectedprogram: any,
  ) => {
    try {
      // Get the program's registration ID
      const program = programs.find((p) => p.id === programId);

      if (!program?.registrationId) {
        console.error("No registration ID found");
        return;
      }
      // Get registration status
      const status = await getRegistrationStatus(program.registrationId);
      // Determine which section to navigate to based on status
      let targetSectionId = sectionId;
      if (status.approvalStatus === "pending") {
        targetSectionId = 1;
      } else if (
        status.approvalStatus === "approved" &&
        status.paymentStatus !== "online_completed" &&
        status.paymentStatus !== "offline_pending" &&
        status.paymentStatus !== "offline_completed"
      ) {
        targetSectionId = 2;
        console.log("targetSectionId", targetSectionId, sectionId);
        // If the user is not in section 3
        if (targetSectionId !== sectionId) {
          alert(
            `congratulations you have been blessed for ${selectedprogram.blessesProgram?.name}, please click ok to check your registration status`,
          );
          setReloadPage(true);
          return;
        }
      } else if (
        status.approvalStatus === "approved" &&
        (status.paymentStatus === "online_completed" ||
          status.paymentStatus === "offline_pending" ||
          status.paymentStatus === "offline_completed")
      ) {
        targetSectionId = 3;
      }
      navigate(`registration?programId=${programId}`, {
        state: { sectionId: targetSectionId },
      });
    } catch (error) {
      console.error("Error in handleCTAClick:", error);
      // Fallback to original behavior if status check fails
      navigate(`registration?programId=${programId}`, {
        state: { sectionId },
      });
    }
  };

  const handleSummaryNavigation = (programId: number) => {
    navigate(`summary?programId=${programId}`);
  };

  const handleRandomLoopEnd = () => {
    console.log("Random loop ended, showing play again button");
    setShowPlayAgainButton(true);
    setPlayMahatreyaAudioMessages(false);
  };

  const handleCeaseUnfolding = () => {
    setShowCountdown(false);
    setShowTimer(false);
    setIsPlaying(false);
    setCurrentTime(0);
    setCurrentLyricIndex(-1);
    setPlayMahatreyaAudioMessages(false);
    setShowContent(true);

    const audio = audioRef.current;
    if (audio) {
      audio.pause();
      audio.currentTime = 0;
    }
  };

  return (
    <>
      <div className={styles.main_view}>
        {renderPillars()}
        {renderLogos()}
        <div className={styles.main_content}>
          <div>
            {showContent || showPlayAgainButton || playMahatreyaAudioMessages
              ? renderGreetings()
              : null}
            {playMahatreyaAudioMessages && (
              <RandomLoopAudioPlayer
                audioUrls={mahatreyaAudioMessages}
                onEnded={handleRandomLoopEnd}
              />
            )}
            <div>
              {showContent &&
                !isPlaying &&
                !showCountdown &&
                !showTimer &&
                !playMahatreyaAudioMessages &&
                !showPlayAgainButton && (
                  <Button
                    onClick={handleStart}
                    buttonClassName={clsx(
                      styles.shortconfirmButton,
                      styles.startButton,
                    )}
                    buttonTextClassName={styles.confirmText}
                  >
                    infiniminute
                  </Button>
                )}
              {showPlayAgainButton && (
                <Button
                  onClick={handleStart}
                  buttonClassName={styles.playAgainButton}
                  buttonTextClassName={styles.playAgainText}
                >
                  play again
                </Button>
              )}
              {showCountdown && (
                <ScrollingCountdown
                  isVisible={showCountdown}
                  onComplete={handleCountdownComplete}
                  current={currentNumber}
                  setCurrent={setCurrentNumber}
                />
              )}

              {/* <div className={styles.prayer_wrapper}> */}
              <div
                className={`${styles.prayer_text} ${isPlaying && !showTimer ? styles.visible : styles.hidden}`}
              >
                {Array.from({ length: isMobile ? 4 : 3 }, (_, i) => {
                  const lyricIndex = Math.max(0, currentLyricIndex - 1) + i;
                  const lyric = lyrics[lyricIndex];
                  if (!lyric) return null;

                  const isActive =
                    lyricIndex === currentLyricIndex ||
                    lyricIndex === currentLyricIndex + 1;
                  const isCurrent = lyricIndex === currentLyricIndex;

                  return (
                    <p
                      key={`${lyricIndex}-${lyric.time}`}
                      className={`${styles.prayer_line} ${
                        isActive
                          ? isCurrent
                            ? styles.current_line
                            : styles.next_line
                          : styles.inactive_line
                      }`}
                    >
                      {lyric.text}
                    </p>
                  );
                })}
              </div>
              {/* </div> */}

              <CircularTimer
                isVisible={showTimer}
                duration={60}
                onComplete={handleTimerComplete}
              />

              <audio ref={audioRef} preload="metadata">
                <source src={infiniprayeraudio} type="audio/mpeg" />
                Your browser does not support the audio element.
              </audio>
            </div>
          </div>
          <div className="unfolding_wrapper">
            {showCountdown || showTimer || isPlaying ? (
              <div
                className={styles.unfoldingText}
                onClick={handleCeaseUnfolding}
              >
                <span>←</span>
                <span>Cease the unfolding</span>
              </div>
            ) : null}
          </div>
        </div>
        {programs && programs.length ? (
          <div className={`${styles.programs_grid}`}>
            {programs.map((program) => (
              <div
                key={program.id}
                className={`${styles.program_container} ${program.statusMessage && program?.statusMessage?.state != SAVE_DRAFT && program.statusMessage.state != PENDING_APPROVAL && program?.statusMessage?.state != REJECTED && program?.statusMessage?.state != ON_HOLD && program?.statusMessage?.state != WAIT_LIST ? styles.bg_image : ""}`}
              >
                {program?.statusMessage &&
                  program?.statusMessage?.state != SAVE_DRAFT &&
                  program?.statusMessage?.state != PENDING_APPROVAL &&
                  program?.statusMessage?.state != WAIT_LIST &&
                  program?.statusMessage?.state != REJECTED &&
                  program?.statusMessage?.state != ON_HOLD && (
                    <>
                      <div className={styles.program_status}>
                        <p>Congratulations!</p>
                        <p>
                          You have been blessed with {" "}
                          {program?.blessesProgram?.name}
                        </p>
                      </div>
                      <div className={styles.seprationLine}></div>
                    </>
                  )}
                <div key={program.id} className={styles.program_card}>
                  <div className={styles.program_header}>
                    <div className={styles.program_icon}>
                      <img
                        src={program.bannerImageUrl || hdbImg}
                        alt={program.title}
                        className={styles.program_icon_image}
                      />
                    </div>
                    <div className={styles.program_content}>
                      {(!program.statusMessage ||
                        program.statusMessage.state == SAVE_DRAFT) && (
                        <div>
                          <p className={styles.program_subtitle}>
                            {program.name}
                          </p>
                          <div className={styles.program_description}>
                      {highlightMahatria (program.description ||"A residential spiritual retreat with Mahatria.")}
                          </div>
                          <div className={styles.subProgramName}>
                            <span className={styles.subProgramList}>
                              {program?.groupedPrograms?.map(
                                (subProgram, index) => (
                                  <span key={index}>
                                    {" "}
                                    {subProgram.name}
                                    {index < program.groupedPrograms.length - 1
                                      ? ","
                                      : ""}{" "}
                                  </span>
                                ),
                              )}
                            </span>
                          </div>
                          {program.endsAt && (
                            <p className={styles.program_date}>
                              Venue: {""}
                              {program.venue}
                            </p>
                          )}
                        </div>
                      )}
                      {program.statusMessage &&
                        program.statusMessage.state != SAVE_DRAFT && (
                          <div>
                            <p className={styles.program_subtitle}>
                              {program.name}
                            </p>
                            {program?.statusMessage.message.map((item) => (
                              <div className={styles.program_description}>
                                {highlightKeywords(
                                  item,
                                  () => onInvoiceClick(program.registrationId),
                                  () => onProformaClick(program.registrationId),
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                      <div className={styles.program_dates_section}>
                        <div className={styles.card_register_button}>
                          {!program.statusMessage ? (
                            <Button
                              onClick={() => handleRegister(program.id)}
                              buttonClassName={styles.confirmButton}
                              buttonTextClassName={styles.confirmText}
                            >
                              apply
                            </Button>
                          ) : (
                            <div className={styles.buttonContainer}>
                              {program.statusMessage.state == SAVE_DRAFT && (
                                <Button
                                  onClick={() => {
                                    handleCTAClick(program?.id, 1, program);
                                  }}
                                  buttonClassName={styles.resumeButton}
                                  buttonTextClassName={styles.resumeButton}
                                >
                                  resume registration
                                </Button>
                              )}
                              {(program.statusMessage.state ==
                                PENDING_APPROVAL|| program.statusMessage.state == ON_HOLD) && (
                                <Button
                                  onClick={() => {
                                    handleCTAClick(program?.id, 1, program);
                                  }}
                                  buttonClassName={styles.secondaryButton}
                                >
                                  edit registration
                                </Button>
                              )}
                              {program.statusMessage.state == COMPLETED && (
                                <Button
                                  onClick={() => {
                                    handleSummaryNavigation(program?.id);
                                  }}
                                  buttonClassName={styles.secondaryButton}
                                >
                                  summary
                                </Button>
                              )}
                              {program.statusMessage.state == PENDING && (
                                <Button
                                  onClick={() => {
                                    handleCTAClick(program?.id, 2, program);
                                  }}
                                  buttonClassName={styles.confirmButton}
                                  buttonTextClassName={styles.confirmText}
                                >
                                  make payment
                                </Button>
                              )}
                              {program.statusMessage.state ==
                                TRAVEL_PENDING && (
                                <div className={styles.travelButtonContainer}>
                                  <Button
                                    onClick={() => {
                                      handleCTAClick(program?.id, 3, program);
                                    }}
                                    buttonClassName={styles.confirmButton}
                                    buttonTextClassName={styles.confirmText}
                                  >
                                    {program?.travelInfo?.length > 0 &&
                                    program?.travelInfo[0]?.travelInfoStatus ===
                                      SAVE_DRAFT ? (
                                      <span>resume travel</span>
                                    ) : (
                                      <span>update travel plan</span>
                                    )}

                                    {/* plan travel */}
                                  </Button>
                                  {/* <span>or</span>
                                      <Button
                                        onClick={() => {
                                          handleCTAClick(program?.id, 3);
                                        }}
                                        buttonClassName={styles.secondaryButton}
                                        // buttonTextClassName={styles.confirmText}
                                      >
                                        fill in manually
                                      </Button> */}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                        <div
                          className={styles.more_data}
                          onClick={() =>
                            setShowMoreId(
                              showMoreId === program.id ? null : program.id,
                            )
                          }
                        >
                          <span> view details </span>
                          <div className={styles.caretIcon}>
                            <img
                              src={
                                showMoreId === program.id ? caretDown : caretUp
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {showMoreId === program.id && (
                    <div className={styles.seprationLine}></div>
                  )}
                  <div>
                    {program.isGroupedProgram ? (
                      program.blessesProgram ? (
                        showMoreId === program.id && (
                          <ProgramInfoTable
                            subPrograms={[program.blessesProgram]}
                          />
                        )
                      ) : (
                        showMoreId === program.id && (
                          <ProgramInfoTable
                            subPrograms={program.groupedPrograms}
                          />
                        )
                      )
                    ) : program?.noOfSession && program?.noOfSession > 0 ? (
                      program.blessesProgram ? (
                        showMoreId === program.id && (
                          <ProgramInfoTable
                            subPrograms={[program.blessesProgram]}
                          />
                        )
                      ) : (
                        showMoreId === program.id && (
                          <ProgramInfoTable subPrograms={program.sessions} />
                        )
                      )
                    ) : (
                      <ProgramInfoCard
                        title={program.name}
                        programDates={
                          program.startsAt && program.endsAt
                            ? formatDateRangeToIST(
                                program.startsAt,
                                program.endsAt,
                              )
                            : ""
                        }
                        checkInTime={
                          program.checkinAt
                            ? `${formatCheckinTime(program.checkinAt)}`
                            : ""
                        }
                        checkOutTime={
                          program.checkoutAt
                            ? `Latest by ${formatCheckinTime(program.checkoutAt)}`
                            : ""
                        }
                        investment={
                          program.basePrice
                            ? `INR ${(parseFloat(program.basePrice) + (parseFloat(program.basePrice) * parseFloat(program.igst || "0")) / 100).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}/-\n(plus GST 18%)`
                            : ""
                        }
                      />
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : null}
        
           <div className={`${styles.programs_card}`}>
          <div className={styles.program_container}>
            <div className={styles.program_header}>
              <div className={styles.program_icon}>
                <img
                  src={infinipathMeet}
                  alt={infinipathMeet.title}
                  className={styles.program_icon_image}
                />
              </div>
              <div className={styles.program_content}>
                <p className={styles.program_subtitle}>infinipath</p>
                <div className={styles.program_description}>
                  Weekly live online growth sessions with{" "}
                  <span className={styles.mahatriaText}>Mahatria</span>,
                  offering consistent wisdom and practical insights for holistic
                  abundance and personal transformation.
                </div>
                <div className={styles.program_description}>
                  Register for live Zoom sessions Every SUNDAY (10 a.m. to 11:15
                  a.m. IST).
                </div>

                <Button
                  // onClick={() => handleRegister(program.id)}
                  buttonClassName={styles.confirmButton}
                  buttonTextClassName={styles.confirmText}
                >
                  register
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default InfiniPrayer;

const highlightKeywords = (
  text: string,
  onInvoiceClick: () => void,
  onProformaClick: () => void,
) => {
  const regex = /(here|Tax invoice|Mahatria| Pro-forma Invoice)/gi;
  const parts = text.split(regex);

  // Check if both "here" and "invoice" appear in the message
  const hasHere = /here/i.test(text);
  const hasTaxInvoice = /Tax invoice/i.test(text);
  const hasProformaInvoice = /Pro-forma Invoice/i.test(text);
  return (
    <>
      {parts.map((part, idx) => {
        if (/^Mahatria$/i.test(part)) {
          return (
            <span key={idx} className={styles.mahatria}>
              {part}
            </span>
          );
        }
        if (/^here$/i.test(part)) {
          // If both "here" and "invoice" are present, only "here" is a link
          return (
            <span key={idx} className={styles.linkUnderlined } onClick={hasTaxInvoice?onInvoiceClick: onProformaClick}>
              {part}
            </span>
          );
        }
        // if (/^invoice$/i.test(part)) {
        //   if (hasHere && hasTaxInvoice) {
        //     // If both are present, invoice is plain text
        //     return <span key={idx}>{part}</span>;
        //   } else {
        //     // If only invoice is present, make it a link
        //     return (
        //       <span key={idx} className={styles.link} onClick={onInvoiceClick}>
        //         {part}
        //       </span>
        //     );
        //   }
        // }
        return part;
      })}
    </>
  );
};
